"use client";
import { jsx as n } from "react/jsx-runtime";
import * as t from "@radix-ui/react-navigation-menu";
import { forwardRef as o } from "react";
import { appendToChildren as s } from "../../../utils/appendToChildren.mjs";
import { DEFAULT_ICON_CLASS_NAME as m } from "../../../utils/iconDefaults.mjs";
import { ChevronDown as u } from "../Icon/icons.gen.mjs";
const v = o((a, i) => /* @__PURE__ */ n(t.Root, { "data-slot": "navigation-menu", ...a, ref: i }));
v.displayName = "NavigationMenuRoot";
const N = o((a, i) => /* @__PURE__ */ n(t.Sub, { "data-slot": "navigation-menu-sub", ...a, ref: i }));
N.displayName = "NavigationMenuSub";
const d = o((a, i) => /* @__PURE__ */ n(t.List, { "data-slot": "navigation-menu-list", ...a, ref: i }));
d.displayName = "NavigationMenuList";
const l = o((a, i) => /* @__PURE__ */ n(t.Item, { "data-slot": "navigation-menu-item", ...a, ref: i }));
l.displayName = "NavigationMenuItem";
const p = o(
  ({
    children: a,
    icon: i = /* @__PURE__ */ n(
      u,
      {
        "data-slot": "navigation-menu-trigger-icon",
        "aria-hidden": "true",
        className: m
      }
    ),
    asChild: e,
    ...r
  }, g) => /* @__PURE__ */ n(t.Trigger, { "data-slot": "navigation-menu-trigger", asChild: e, ...r, ref: g, children: s(a, i, e) })
);
p.displayName = "NavigationMenuTrigger";
const M = o((a, i) => /* @__PURE__ */ n(t.Content, { "data-slot": "navigation-menu-content", ...a, ref: i }));
M.displayName = "NavigationMenuContent";
const c = o((a, i) => /* @__PURE__ */ n(t.Link, { "data-slot": "navigation-menu-link", ...a, ref: i }));
c.displayName = "NavigationMenuLink";
const y = o((a, i) => /* @__PURE__ */ n(t.Indicator, { "data-slot": "navigation-menu-indicator", ...a, ref: i }));
y.displayName = "NavigationMenuIndicator";
const f = o((a, i) => /* @__PURE__ */ n(t.Viewport, { "data-slot": "navigation-menu-viewport", ...a, ref: i }));
f.displayName = "NavigationMenuViewport";
export {
  M as NavigationMenuContent,
  y as NavigationMenuIndicator,
  l as NavigationMenuItem,
  c as NavigationMenuLink,
  d as NavigationMenuList,
  v as NavigationMenuRoot,
  N as NavigationMenuSub,
  p as NavigationMenuTrigger,
  f as NavigationMenuViewport
};
